import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Spinner } from 'react-bootstrap';
import { getAvailableAmount } from '../../services/available-amount.service';
import { useAuth } from '../components/autentication-context.component';
import EnterAmountModal from '../components/enter-amount.modal.component';
import { useNavigate } from 'react-router-dom';
import { LogoutProps } from '../interfaces/logout.interface';
import { handleApiError } from '../../services/error.service';

const MyWages: React.FC<LogoutProps> = ({ handleLogout }) => {
  const { employeeId, token, updateToken } = useAuth();
  const [available, setAvailable] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [notification, setNotification] = useState<{ type: 'success' | 'error'; message: string } | null>(null);

  const [showModal, setShowModal] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!employeeId || !token) return;

    const fetchAmount = async () => {
      try {
        const data = await getAvailableAmount(employeeId, token, updateToken);
        if (!data) {
          setNotification({ type: 'error', message: 'Failed to get amount.' });
          return;
        }
        setAvailable(data.amount);

      } catch (error) {
        handleApiError({ error, handleLogout, setNotification });

      } finally {
        setLoading(false);
      }
    };

    fetchAmount();
  }, [employeeId, token]);

  const handleAmountClick = (amount: number) => {
    if (amount > available!) {
      setNotification({ type: 'error', message: `The amount requested($${amount}) exceeds the available limit` });
      return;
    }
    navigate('/accounts', { state: { amountToDeposit: amount } });
  };

  const handleCustomAmountConfirm = (amount: number) => {
    setShowModal(false);
    if (amount > available!) {
      setNotification({ type: 'error', message: `The amount requested($${amount}) exceeds the available limit` });
      return;
    }
    //Navigate to DestinationAccounts with amountToDeposit
    navigate('/accounts', { state: { amountToDeposit: amount } });

  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center text-center mb-5">
        <Col xs={12} md={6}>
          <h5 className="text-muted mb-4">Available</h5>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" variant="light" />
              <p>Loading balance...</p>
            </div>
          ) : (
            <>
              <h1 className="display-4 greenColour mb-5">
                ${available?.toFixed(2)}
              </h1>
              {notification?.type == "error" && <p className="text-danger mt-2">{notification.message}</p>}
            </>
          )}
        </Col>
      </Row>

      <Row className="justify-content-center mb-3">
        <p className='greenColour'>Amount</p>
        <Col xs={12} md={6}>
          <Row className="g-2">
            <Col xs={4}>
              <Button variant="" className="w-100 py-3 btn-lg greenButton" onClick={() => handleAmountClick(20)}>$20</Button>
            </Col>
            <Col xs={4}>
              <Button variant="light" className="w-100 py-3 btn-lg greenButton" onClick={() => handleAmountClick(40)}>$40</Button>
            </Col>
            <Col xs={4}>
              <Button variant="light" className="w-100 py-3 btn-lg greenButton" onClick={() => handleAmountClick(60)}>$60</Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col xs={12} md={6}>
          <Row className="g-2">
            <Col xs={4}>
              <Button variant="light" className="w-100 py-3 btn-lg greenButton" onClick={() => handleAmountClick(80)}>$80</Button>
            </Col>
            <Col xs={4}>
              <Button variant="light" className="w-100 py-3 btn-lg greenButton" onClick={() => handleAmountClick(100)}>$100</Button>
            </Col>
            <Col xs={4}>
              <Button variant="secondary" className="w-100 py-3 btn-lg greenButton" onClick={() => setShowModal(true)}>Other</Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <EnterAmountModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleCustomAmountConfirm}
      />
    </Container>
  );
};

export default MyWages;